import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import socket from "../../../context/socket";
import _ from "lodash";

import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import ClipLoader from "react-spinners/ClipLoader";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { capitalizeText, } from "../../../utils/inputsValidation";
import { fetchClientData } from "../../../redux/client/clientSlice";
import { fetchAdvisorData } from "../../../redux/advisor/advisorSlice";
import api from "../../../utils/api";

const Dream = ({ isDarkMode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const videoRef = useRef(null);
  const roomId = useMemo(() => new URLSearchParams(location.search).get("clientId"), [location.search]);

  const [message, setMessage] = useState("");
  const [videoEnded, setVideoEnded] = useState(false);

  const { clientData, loading: clientLoading, error: clientError } = useSelector(state => state.client);
  const { advisorData } = useSelector(state => state.advisor);

  const lastItem = useMemo(() => {
    const parts = advisorData?.advisorName?.split(" ");
    return parts?.[parts.length - 1] || "";
  }, [advisorData]);

  const fullName = useMemo(() => {
    return `${clientData.firstName || ""} ${clientData.middleName || ""} ${clientData.lastName || ""}`.trim();
  }, [clientData]);

  const calculateAge = (dob) => moment().diff(moment(dob), "years");

  const age = useMemo(() => calculateAge(clientData.dob), [clientData.dob]);

  const ageMessage = useMemo(() => {
    if (age >= 16 && age <= 28) return "Starting early gives you the advantage of time, letting compounding work in your favor!";
    if (age >= 29 && age <= 39) return "You’re in the prime of your earning years—smart financial planning now will pay off immensely!";
    if (age >= 40 && age <= 50) return "Planning for retirement and your family's future becomes crucial at this stage!";
    if (age > 50) return "Securing a stable future with the right investments and risk management is key now!";
    return "Building financial awareness is always a great decision at any age!";
  }, [age]);


  const debouncedEmitMessage = useMemo(() => _.debounce((msg) => {

    socket.emit("message", { room: roomId, message: msg });
  }, 300), [roomId]);


  const handleLoadedMetadata = () => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 2 // Speed 2x
    }
  };

  const handleChange = (e) => {
    const newMessage = capitalizeText(e.target.value);
    setMessage(newMessage);

    api.post(`advisor/save_user_about_2`, {
      _id: String(roomId),
      city: newMessage,
    }).then(res => {
      console.log("Message saved:", res.data);
    }).catch(err => {
      console.error("Error saving message:", err);
    });
    videoEnded && debouncedEmitMessage(newMessage);
  };



  const handleNext = () => {
       const nextUrl = `/financial-plan?clientId=${roomId}`;
    const nextUrl2 = `/financial-plan`;

    socket.emit("navigate", { room: roomId, url: nextUrl2 });
    navigate(nextUrl);
    // api.post(`advisor/save_user_about_2`, {
    //   _id: String(roomId),
    //   city: message,
    // }).then(() => {

    // }).catch(console.error);
  };

  const handleBack = () => {
     const prevUrl = `/?clientId=${roomId}`;
    const prevUrl2 = `/`;
    socket.emit("navigate", { room: roomId, url: prevUrl2 });
    navigate(prevUrl);
  };

  // Initial data fetch
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      const decoded = jwtDecode(token);
      dispatch(fetchAdvisorData(decoded.id));
    }
  }, [dispatch]);

  useEffect(() => {
    if (clientData.city) {
      setMessage(clientData.city);
    }
  }, [clientData.city]);

  console.log("clientedatat", clientData)

  // Socket handling
  useEffect(() => {
    socket.emit("join", { room: roomId });

    const handleMessage = (msg) => console.log("Message from client:", msg);
    socket.on("message", handleMessage);

    return () => socket.off("message", handleMessage);
  }, [roomId]);


  const isMobile = window.innerWidth <= 768;

  if (clientLoading) {
    return (
      <div className="container py-4">
        {/* Title Skeleton */}
        {/* <Skeleton height={40}   style={{ marginBottom: 20 }} /> */}

        <div className="row g-5 align-items-start">
          {/* Left: Large Profile Circle */}
          <div className="col-12 col-md-6 text-center">
            <Skeleton
              circle
              width={isMobile ? 180 : 300}
              height={isMobile ? 180 : 300}
            />
          </div>

          {/* Right: Content blocks */}
          <div className="col-12 col-md-6">
            {[1, 2, 3].map((item) => (
              <div className="d-flex align-items-start gap-3 mb-4" key={item}>
                <Skeleton
                  circle
                  width={50}
                  height={50}
                />
                <Skeleton
                  width={isMobile ? 300 : 500}
                  height={100}
                />
              </div>
            ))}
          </div>
        </div>

        <Skeleton height={60} width={'100%'} style={{ marginBottom: 20, borderRadius: 40 }} />
      </div>
    );
  }

  const fullNameText = `${clientData?.salutation || ''} ${clientData?.firstName || clientData?.lastName || clientData?.middleName || ''
    }'s`;

  const isLongText = fullNameText?.replace(/\s+/g, '').length > 13;


  if (clientError) return <div>Error loading client data</div>;

  return (
    <>
      <div className="container minht">
        <div className="row gx-5">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 text-center">
              <h2 className="text-success fs-1 fw-semibold fst-italic">Every Dream Begins with a Plan!</h2>
            </div>


          </div>
          <div className="d-flex flex-column justify-content-center">
            <div className="card shadow my-4 px-4 py-2  " style={{ border: "0px", backgroundColor: isDarkMode ? "" : "#F4F6FF" }}>
              <div className="d-flex justify-content-center gap-3 ">
                <img
                  src="assets/images/ICON-1.svg"
                  alt=""
                  width={50}
                  height={50}
                  className="darkmodechnge"
                />
                <p className=" fw-normal  fs-21 clrgreen ">
                  Our industry is plagued by mis-selling and investors are often sold products that are not in best interest.
                  <span className="fw-medium">We exist to bridge that gap.</span>
                </p>
              </div>

              <div className="d-flex justify-content-center gap-3 ">
                <img
                  src="assets/images/ICON-2.svg"
                  alt=""
                  width={50}
                  height={50}
                  className="darkmodechnge"

                />
                <p className=" fw-normal fs-21 clrgreen ">
                  We have <span className="fw-medium">no sales or revenue targets </span> to ensure our interests are aligned with yours.
                  The quality of our advice is guided by a <span className="fw-medium">strond investing process to ensure your financial goals are met. </span>
                </p>
              </div>
            </div>
          </div>
          {/* Left Column: Video */}
          <div className="col-lg-6 col-md-12 m-n5  mb-6 d-flex justify-content-lg-end justify-content-center">
            <div className="image-wrapper">
              <video
                ref={videoRef}
                key={isDarkMode ? "dark" : "light"}
                className="w-100 w-lg-auto"
                playsInline   // iOS fix
                webkit-playsinline="true" // Older iOS Safari support
                muted
                autoPlay        // Optional but improves reliability
                preload="auto" // Helps slow networks
                style={{
                  maxWidth: "800px",
                  height: "auto",
                  background: "transparent",
                  border: "none",
                  display: "block",
                }}
                onLoadedMetadata={handleLoadedMetadata}
                onEnded={() => setVideoEnded(true)}
              >
                <source
                  // src={"/assets/images/process3.m4v"}
                  src={isDarkMode ? "https://cb.finedge.in/assets/images/Process-dark.mp4" : "https://cb.finedge.in/assets/images/process3.m4v"}
                  type="video/x-m4v"
                />
                Your browser does not support the video tag.
              </video>

              <div>
                {/* MOBILE */}
                <div className="d-md-none">
                  <div
                    className={`overlay-text clrgreen ${isLongText ? 'fs-6 ' : 'fs-4'}`}
                   
                  >
                    {fullNameText}
                  </div>

                  <div
                    className={`overlay-subtext clrgreen ${isLongText ? 'fs-6' : 'fs-5'}`}

                  >
                    Investing Process
                  </div>
                </div>

                {/* DESKTOP */}
                <div className="d-none d-md-block">
                  <div className="overlay-text fs-4 clrgreen">
                    {fullNameText}
                  </div>
                  <div className="overlay-subtext fs-5 clrgreen">
                    Investing Process
                  </div>
                </div>
              </div>

            </div>
          </div>



          {/* Right Column: Text, displayed only after video ends */}
          {videoEnded && (
            <div className="col-lg-6 col-md-12 mt-3 mt-lg-0">
              <div className="d-flex justify-content-center align-items-center h-100">
                <div className="card shadow mb-4 py-3 px-4 white-bggreen border-none">
                  <span className="fs-4 fw-medium text-center mb-2  ">Trust the Investing Process!</span>
                  <span className="fs-21 ">
                    <span className="fw-medium">We never begin with a product; it is the outcome of a process built around your goals. </span>
                    DiA hard-codes investing best practices into the platform, enabling you not just to invest, but to achieve your goals.
                    It is built around your financial background, risk comfort, and long-term objectives
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>


      </div>
      {/* Navigation arrows */}
      <div className="container mb-4">
        <div className="row">
          <div className="col text-end">
            <a href="javascript:void(0);" onClick={handleBack}>
              <img
                className="arrow_next1"
                src="assets/images/left-arrowpng.png"
                alt="Previous"
              />
            </a>
            <a
              href="javascript:void(0);"
              className="ms-1"
              onClick={
                videoEnded
                  ? handleNext
                  : () => {
                    setVideoEnded(true);
                    debouncedEmitMessage(true);
                  }
              }
            >
              <img
                className="arrow_next"
                src="assets/images/right-arrow.svg"
                alt="Next"
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dream;
